import { useEffect } from "react";
import { useNavigate } from "react-router";

import { storage } from "@/lib/storage";

export const CatchAllPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // Try sending the user to the "home" page if the user exists in local storage
      // and has at least one company associated with them. Otherwise, send them to
      // the sign-in page.
      //
      // Perhaps in the future we can intelligently route the user to their most
      // recently accessed company if they have access to more than one company.
      // This isn't a priority for now though.
      const user = storage.getUser();
      if (user?.companies.length) {
        // TODO: Unified way to navigate to the first company since this is a common pattern.
        void navigate(`/companies/${user.companies[0].id}`);
      } else {
        void navigate("/sign-in");
      }
    } catch {
      // TODO: Unified way to navigate to the sign-in page since this is a common pattern.
      void navigate("/sign-in");
    }
  }, [navigate]);

  return null;
};
